export default "__VITE_ASSET__DMNNzx5r__"